import {useAppDispatch} from "../../../../hooks/hooks";
import {useCallback} from "react";
import {finishCounselingAsync} from "../../../../store/counselorSlice";
import {ErrorType} from "../../../../types/error";
import {getErrorType} from "../../../../util/sliceUtil";

export function useHistoryFunctions() {
    /**
     * 상담내역 내 별도 API 처리 컴포넌트
     */

    const dispatch = useAppDispatch();

    // 상담 종료 API
    const finishCounseling = useCallback(
        async (param: number) => {
            try {
                await dispatch(finishCounselingAsync(param)).unwrap();
                alert('상담이 종료되었습니다.')
                window.location.reload();
            } catch (e) {
                const errors: ErrorType = getErrorType(e as Error);
                console.error(errors)
                const errorMessage =errors.errorCode.msg

                alert(errorMessage);
                return false;
            }
            //eslint-disable-next-line
        }, [dispatch]);

    return{
        finishCounseling,
    }
}